import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import he from "./locales/he.json";

const STORAGE_KEY = "dyna-lang";

// Initialize with English explicitly so SSR and client first-render produce
// identical translated text. The browser language detector used to run at
// init time, but it can't run on the server (no localStorage / navigator),
// so it returned the fallback while the client returned whatever was stored
// or detected — guaranteed hydration mismatch on every translated string.
//
// Detection now runs in detectLanguageOnMount() called from RootLayout's
// useEffect, after hydration completes. Hebrew users see a brief flash of
// English, then the language switches.
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      he: { translation: he },
    },
    lng: "en",
    fallbackLng: "en",
    supportedLngs: ["en", "he"],
    interpolation: { escapeValue: false },
  });

const applyDir = (lng: string) => {
  if (typeof document === "undefined") return;
  const dir = lng === "he" ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", lng);
};

i18n.on("languageChanged", applyDir);

/** Run after mount to swap to the user's stored or detected language. */
export function detectLanguageOnMount(): void {
  if (typeof window === "undefined") return;
  const stored = window.localStorage.getItem(STORAGE_KEY);
  let target = stored;
  if (!target && typeof navigator !== "undefined") {
    const nav = navigator.language?.toLowerCase() ?? "";
    target = nav.startsWith("he") ? "he" : "en";
  }
  if (target && target !== i18n.language && (target === "en" || target === "he")) {
    void i18n.changeLanguage(target).then(() => {
      window.localStorage.setItem(STORAGE_KEY, target!);
    });
  }
}

export default i18n;
